import {useEffect, useRef} from 'react';

import type {LiveEvent} from '../ballotTypes';

const TYPES = ['state', 'joined', 'voted'] as const;

export const useEventStream = (url: string | null, onEvent: (event: LiveEvent) => void): void => {
    const handler = useRef(onEvent);
    handler.current = onEvent;

    useEffect(() => {
        if (!url) return;
        const source = new EventSource(url);
        // A reconnect may have missed events, so treat every open as a state change.
        source.onopen = () => handler.current({type: 'state'});
        const listeners = TYPES.map((type) => {
            const listener = ((message: MessageEvent<string>) =>
                handler.current(JSON.parse(message.data) as LiveEvent)) as EventListener;
            source.addEventListener(type, listener);
            return [type, listener] as const;
        });
        return () => {
            for (const [type, listener] of listeners) source.removeEventListener(type, listener);
            source.close();
        };
    }, [url]);
};
